import React from "react";
import { Navigate } from "react-router-dom";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH, AUTHENTICATED_ENTRY } from "configs/AppConfig";
import { REGIME_PATHS_MERGED_INTO_ELECTRICAL_REGIME } from "configs/NavigationConfig";

// Instrumentation & Control, Piping & Pressure Systems, Civil & Structural, Cleaning/Sanitation
// & Housekeeping and Safety/Fire & Environmental (HSE) no longer have their own standalone page —
// they're tabs inside Electrical Regime now. A stale/typed-in link to one of their old routes
// sends the user to Electrical Regime instead of rendering the old standalone screen.
const RegimeRedirect = () => (
  <Navigate to={`${APP_PREFIX_PATH}/ElectricalRegime`} replace />
);

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "register",
    path: `${AUTH_PREFIX_PATH}/register`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
];
export const GetProtectedRoutes = (roleList) => {
  const routesList = roleList
    .filter((role) => role.menuName && role.path && role.isLeaveNode === true)
    .map((role) => ({
      key: role.menuName.toLowerCase(),
      path: `${APP_PREFIX_PATH}/${role.path}`,
      component: REGIME_PATHS_MERGED_INTO_ELECTRICAL_REGIME.includes(role.path)
        ? RegimeRedirect
        : React.lazy(() =>
            import(`views/app-views/${role.path}/${role.path}`)
          ),
    }));

  // A user granted only e.g. PipingPressureSystems (without the ElectricalRegime role itself)
  // still gets a RegimeRedirect route above pointing at /app/ElectricalRegime — make sure that
  // target actually exists, otherwise the redirect lands on a route nothing registered and the
  // page never renders. Which tabs show once there is filtered independently inside the page
  // itself (see ElectricalRegime.js), so this only affects reachability, not visibility.
  const hasElectricalRegimeRole = roleList.some((role) => role.path === "ElectricalRegime");
  const hasOtherRegimeRole = roleList.some((role) =>
    REGIME_PATHS_MERGED_INTO_ELECTRICAL_REGIME.includes(role.path)
  );
  if (!hasElectricalRegimeRole && hasOtherRegimeRole) {
    routesList.push({
      key: "electricalregime",
      path: `${APP_PREFIX_PATH}/ElectricalRegime`,
      component: React.lazy(() =>
        import(`views/app-views/ElectricalRegime/ElectricalRegime`)
      ),
    });
  }

  routesList.push({
    key: "change-password",
    path: `${AUTH_PREFIX_PATH}/change-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/change-password")
    ),
  });
  routesList.push({
    key: "coming-soon",
    path: `${APP_PREFIX_PATH}/isParent`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-2")),
  });
  routesList.push({
    key: "welcome-page",
    path: AUTHENTICATED_ENTRY,
    component: React.lazy(() => import("views/app-views/Welcome/Welcome")),
  });
  return routesList;
};
